import AutoAwesomeOutlinedIcon from '@mui/icons-material/AutoAwesomeOutlined'
import CreditCardOutlined from '@mui/icons-material/CreditCardOutlined'
import GroupOutlined from '@mui/icons-material/GroupOutlined'
import NotificationsOutlined from '@mui/icons-material/NotificationsOutlined'
import PersonOutlined from '@mui/icons-material/PersonOutlined'
import { SettingsSection } from '../types/settings.types'

type SectionConfig = {
  id: SettingsSection
  label: string
  icon: React.ComponentType<{ className?: string }>
}

export const SETTINGS_SECTIONS: Record<SettingsSection, SectionConfig> = {
  workspace: {
    id: 'workspace',
    label: 'Workspace Settings',
    icon: GroupOutlined,
  },
  people: {
    id: 'people',
    label: 'People',
    icon: GroupOutlined,
  },
  plans: {
    id: 'plans',
    label: 'Plans & Billing',
    icon: CreditCardOutlined,
  },
  profile: {
    id: 'profile',
    label: 'Account Profile',
    icon: PersonOutlined,
  },
  aiSettings: {
    id: 'aiSettings',
    label: 'AI Settings',
    icon: AutoAwesomeOutlinedIcon,
  },
  notifications: {
    id: 'notifications',
    label: 'Notifications',
    icon: NotificationsOutlined,
  },
}
